import FAQPage from './faqPage.component';

export default FAQPage;